import React, { Component } from 'react'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import debounce from 'lodash/debounce'

import compareArrays from '../../../helpers/compareArrays'

const acceptTypeOptions = [
  { value: 'image/*', label: 'Images' },
  { value: '.pdf', label: 'PDF' },
  { value: '.doc,.docx', label: 'Word Documents' },
  { value: '.xls,.xlsx', label: 'Excel Files' },
  { value: '*/*', label: 'All Files' }
]

const labelFor = (value) => {
  const match = acceptTypeOptions.find((opt) => opt.value === value)
  return match ? match.label : value
}

export default class FormAcceptTypeField extends Component {
  constructor (props) {
    super(props)

    this.state = {
      value: props.acceptType
    }

    this.onChange = props.onChange
    this.updateValue = this.updateValue.bind(this)
    this.debounced = null
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (
      this.props.acceptType !== nextProps.acceptType ||
      this.state.value !== nextState.value ||
      compareArrays(this.props.newIndexes, nextProps.newIndexes)
    )
  }

  componentDidUpdate (prevProps) {
    if (prevProps.acceptType !== this.props.acceptType && this.props.acceptType !== this.state.value) {
      this.setState({ value: this.props.acceptType })
    }
  }

  updateValue ({ target: { value } }) {
    if (this.debounced && this.debounced.cancel) {
      this.debounced.cancel()
    }
    this.debounced = debounce(() => this.onChange({
      value,
      indexes: this.props.newIndexes,
      field: 'acceptType'
    }), 300)
    this.setState({ value }, this.debounced)
  }

  render () {
    if (this.props.isMarked || this.props.newIndexes.length === 1) {
      return (
        <div className='type type-no-select'>{labelFor(this.state.value)}</div>
      )
    }
    return (
      <div className='type'>
        <Select
          onChange={this.updateValue}
          value={this.state.value || ''}
          displayEmpty
          renderValue={(value) => (
            <div className='input'>
              {value ? labelFor(value) : 'Select file type'}
            </div>
          )}
        >
          {acceptTypeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>
      </div>
    )
  }
}
